import { PrizeCarouselItem } from 'types/PrizeCarousel';

export const homepagePrizeCarouselItems: PrizeCarouselItem[] = [
  {
    id: 1,
    title: 'Live-in camper van',
    subheading: '+ £20,000 in spending money',
    imageSrc:
      'https://prize-assets.daymade.co.uk/40527939-ea1f-4075-bd05-4babfe256ee4.jpg',
    slug: 'win-camper-van',
  },
  {
    id: 2,
    title: 'Win a house renovation',
    subheading: '£100K to spend on any work around the house',
    imageSrc:
      'https://prize-assets.daymade.co.uk/3ce6a2bb-d056-43e8-b354-981e8be0d863.jpg',
    slug: 'win-house-renovation',
  },
  {
    id: 3,
    title: 'The ultimate gadget bundle',
    subheading: "Pick 'n' mix your gadgets",
    imageSrc:
      'https://prize-assets.daymade.co.uk/d81533d9-5751-4744-be2f-0ec0317db835.jpg',
    slug: 'the-ultimate-gadget-bundle',
  },
  {
    id: 4,
    title: 'Maldives for 2',
    subheading: '7 nights in paradise',
    imageSrc:
      'https://prize-assets.daymade.co.uk/e71af6e7-7660-4b35-89de-67545bd5f79f.jpg',
    slug: 'maldives',
  },
  {
    id: 5,
    title: '4 days in Iceland for 2',
    subheading: 'Chase the Northern Lights',
    imageSrc:
      'https://images.daymade.co.uk/prize-assets/43ee8552-c4dc-4ece-9de4-712642cfb5a7.jpg',
    slug: 'iceland-northern-lights-2000',
  },
  {
    id: 6,
    title: '7-nights Norwegian Fjord Cruise',
    subheading: 'Magical Norway for 2',
    imageSrc:
      'https://prize-assets.daymade.co.uk/e325dc24-d93d-4a9b-bb3d-e95cb0827584.jpg',
    slug: 'win-a-cruise-to-norway-fjords',
  },
]; // TODO: move this to a cms or at least a constants file. This is just placeholder data for now

export const BOOST_PAGE_PRIZES: PrizeCarouselItem[] = [
  {
    imageSrc:
      'https://daymade-prize-assets.s3.amazonaws.com/40527939-ea1f-4075-bd05-4babfe256ee4.jpg',
    title: 'Live-in camper van',
    subheading: (
      <>
        Plus £20k spending <br /> money
      </>
    ),
  },
  {
    imageSrc:
      'https://daymade-prize-assets.s3.amazonaws.com/3ce6a2bb-d056-43e8-b354-981e8be0d863.jpg',
    title: 'Home renovation',
    subheading: (
      <>
        £100k to spend on any <br /> work that needs doing
      </>
    ),
  },
  {
    imageSrc:
      'https://daymade-prize-assets.s3.amazonaws.com/04821dd5-1f42-468e-8732-65515f1a077a.jpg',
    title: '5 years of holidays',
    subheading: (
      <>
        £20k per year to spend <br />
        on epic holidays
      </>
    ),
  },
  {
    imageSrc:
      'https://daymade-prize-assets.s3.amazonaws.com/b1ba11a6-0b2d-473d-ad5e-c9599f2272cd.jpg',
    title: 'Win a wedding',
    subheading: (
      <>
        All included wedding of <br /> your dreams
      </>
    ),
  },
];
